{
  "help": "Aide",
  "info": "Informations"
}
